// ─── App Version ─────────────────────────────────────────────────────────────
// Update this ONE value — it propagates everywhere (CRM shell, member portal).
export const APP_VERSION = '2.1.8';
